import {
  AssessmentTemplateComplianceRequirement,
  SaveComplianceProgramMutationVariables,
} from "types/graphql-schema";
import { PastOnlyDateRangeEnum } from "types/topicflow";

export enum ProgramFormTab {
  Workflow,
  Questions,
  Participants,
  Notifications,
}

export enum ExtraDateRangeEnum {
  none = "none",
  custom = "custom",
}
export type DateRangeType = ExtraDateRangeEnum | PastOnlyDateRangeEnum;

export type AssessmentTemplateExtraSettings = Partial<
  Pick<
    AssessmentTemplateComplianceRequirement,
    | "anonymity"
    | "providers"
    | "delivery"
    | "talentIndicatorConfig"
    | "enableRoleBasedAssessments"
    | "enableGoalAssessments"
    | "enableCoreValueAssessments"
    | "roleBasedAssessmentsAssessNextRole"
    | "roleBasedAssessmentsSelfAssessNextRole"
    | "competencyAssessmentType"
    | "nextRoleCompetencyAssessmentType"
    | "roleBasedAssessmentScale"
    | "roleBasedAssessmentScaleLabels"
    | "roleBasedAssessmentScaleStartsAt"
    | "goalAssessmentScale"
    | "goalAssessmentScaleLabels"
    | "goalAssessmentScaleStartsAt"
    | "goalAssessmentResponses"
    | "coreValueAssessmentScale"
    | "coreValueAssessmentScaleLabels"
    | "coreValueAssessmentScaleStartsAt"
    | "coreValueAssessmentResponses"
  >
>;

export enum ComplianceProgramType {
  REVIEW = "review",
  ENGAGEMENT_SURVEY = "survey",
  ONE_ON_ONE = "one_on_one",
}

export enum ProgramStartTrigger {
  ON_START_DATE,
  EMPLOYEE_START_DATE,
}

export enum ProgramEvaluationPeriodType {
  PAST_WEEK,
  PAST_TWO_WEEKS,
  PAST_MONTH,
  PAST_TWO_MONTHS,
  PAST_QUARTER,
  PAST_HALF_YEAR,
  PAST_YEAR,
  CUSTOM,
}

export type ProgramForm = SaveComplianceProgramMutationVariables & {
  evaluationPeriod: {
    type: ProgramEvaluationPeriodType;
    startDate?: string;
    endDate?: string;
  };
  sharesWithSubject: boolean;
};
